module.exports = __webpack_public_path__ + "static/media/25.20592e37.jpg";